import React from 'react'
import Button from '../../../components/Button/Button'
import DropDown from '../../../components/DropDown/DropDown'
import CellLocation from '../../../components/Table/components/CellLocation'
import { logErrorOnServer } from '../../../helpers/serverLogging'
import { tagHotjarRecording } from '../../../helpers/util'
import useAuth from '../../../hooks/useAuth'
import PropTypes from 'prop-types'
import RadioButton from '../../../components/RadioButton/RadioButton'
import { useFormik } from 'formik'
import {
    initialValues,
    validationSchema,
} from '../../../forms/UsedEquipmentRequestAvailabilityForm'
import useRequest from '../../../hooks/useRequest'
import useAlert from '../../../hooks/useAlert'
import useGlobalLoading from '../../../hooks/useGlobalLoading'
import AppRoutes from '../../../routes/appRoutes'
import { useHistory } from 'react-router-dom'

const logError = logErrorOnServer('Used Equipment Availability Request')

const UsedEquipmentRequestAvailabilityForm = ({ equipment }) => {
    const history = useHistory()
    const { user } = useAuth()
    const {
        handleCreateRequestUsedEquipment,
        changeNeedsUpdate,
        needsUpdateDashboard,
    } = useRequest()
    const { handleChangeAlert, handleChangeOpen } = useAlert()
    const { changeLoading } = useGlobalLoading()
    const { setFieldValue, values, errors, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: formValues => {
            submitRequest(formValues)
        },
    })

    const selectOptions = user?.locationPreferences

    const formattedShiptos = selectOptions?.map(item => {
        return {
            ...item,
            locationToShow: (
                <CellLocation
                    isInCard
                    label={item?.label}
                    address={item?.address}
                />
            ),
        }
    })

    const onCreatedUsedRequestSuccess = () => {
        changeLoading(false)
        changeNeedsUpdate({
            dashboard: needsUpdateDashboard,
            request: true,
        })
        handleChangeAlert({
            type: 'success',
            title: 'Thank you for your interest!',
            message:
                'A Representative will be in touch shortly to talk about the specifics of your request.',
            textCancel: 'Return to the dashboard',
            textOk: 'New Search',
            onDone: () => {
                handleChangeOpen(false)
                history?.push(AppRoutes.equipmentFinder())
            },
            onCancel: () => {
                handleChangeOpen(false)
                history?.push(AppRoutes.dashboard())
            },
        })
    }

    const onCreatedUsedRequestError = response => {
        changeLoading(false)
        const message = response.data ? response.data.message : 'Request failed'
        tagHotjarRecording('API Error')
        logError(message)
    }

    const submitRequest = formValues => {
        const userId = user?.id
        const companyId = user?.company?.id

        const usedEquipmentRequestInfo = {
            userId,
            companyId,
            equipment,
            ...formValues,
        }
        changeLoading(true)
        handleCreateRequestUsedEquipment(
            usedEquipmentRequestInfo,
            onCreatedUsedRequestSuccess,
            onCreatedUsedRequestError,
        )
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="w-full h-auto flex flex-col items-start justify-start"
        >
            <p className="text-black70 text-sm font-medium mb-4">
                Where do you need it?
            </p>

            <DropDown
                customRender={({ label }) => (
                    <p className="text-textDarkerGray text-base font-normal">
                        {label}{' '}
                    </p>
                )}
                data={formattedShiptos}
                keyId="id"
                keyToShow="locationToShow"
                keyToFind="address"
                setSelectedValue={val =>
                    setFieldValue('selectedLocation', val?.value)
                }
                selected={formattedShiptos?.find(
                    i => i?.value === values?.selectedLocation,
                )}
                placeholder="Select Location"
                className="w-full"
                isSmall
                error={errors['selectedLocation']}
            />

            <RadioButton
                checked={true}
                label="I have a trade in"
                isTextBlack
                value={values['tradeIn']}
                onChange={() => {
                    setFieldValue('tradeIn', !values['tradeIn'])
                }}
            />
            <Button
                text="Request Availability"
                variant="primary"
                type="submit"
                className="w-full mt-4"
            />
        </form>
    )
}

UsedEquipmentRequestAvailabilityForm.propTypes = {
    equipment: PropTypes.object,
}

export default UsedEquipmentRequestAvailabilityForm
